module.exports = __webpack_public_path__ + "h5/img/h5.b2cf6e29.png";